import { Button, Group } from '@mantine-8/core';
import { IconTableExport } from '@tabler/icons-react';
import { type FC } from 'react';
import MantineModal from '../common/MantineModal';
import ExportResults, { type ExportResultsProps } from '../ExportResults';

interface ExportDataModalProps extends ExportResultsProps {
    isOpen: boolean;
    onClose: () => void;
}

const ExportDataModal: FC<ExportDataModalProps> = ({
    isOpen,
    onClose,
    ...exportResultsProps
}) => {
    if (!isOpen) return null;

    return (
        <MantineModal
            opened
            onClose={onClose}
            title="Export Data"
            icon={IconTableExport}
            size="md"
            cancelLabel={false}
        >
            <ExportResults
                {...exportResultsProps}
                renderDialogActions={({ onExport, isExporting }) => (
                    <Group justify="flex-end" gap="xs">
                        <Button variant="default" onClick={onClose}>
                            Cancel
                        </Button>

                        <Button
                            loading={isExporting}
                            onClick={async () => {
                                await onExport();
                            }}
                            data-testid="chart-export-results-button"
                        >
                            Download
                        </Button>
                    </Group>
                )}
            />
        </MantineModal>
    );
};

export default ExportDataModal;
